export default "__VITE_ASSET__B9Mt7drw__"